import React, { useState, useEffect } from 'react';
import { Tabs, Box, Container, SpaceBetween } from '@amzn/awsui-components-react';
import { useParams } from 'react-router-dom';

const MenuBar = ({ onTabChange, activeTab, activeSubTab, isEditMode }) => {
  const { id: appId } = useParams();
  const [activeMainTab, setActiveMainTab] = useState(activeTab || 'actions');
  const [activeSecondaryTab, setActiveSecondaryTab] = useState(activeSubTab || 'upload');

  const allTabs = [
    { 
      id: 'details', 
      label: 'Details and Meta',
      content: <Box></Box>
    },
    { 
      id: 'results', 
      label: 'Results',
      content: <Box></Box>
    },
    { 
      id: 'actions', 
      label: 'Actions',
      content: <Box></Box>
    },
    { 
      id: 'approvals', 
      label: 'App Approvals',
      content: <Box></Box>
    },
    { 
      id: 'audit', 
      label: 'Audit Logs',
      content: <Box></Box>
    }
  ];

  // Filter tabs based on edit mode
  const mainTabs = isEditMode 
    ? allTabs.filter(tab => tab.id === 'details')
    : allTabs;

  const handleMainTabClick = (tabId) => {
    // appId is now available from useParams hook
    // Remove redirects for both approvals and audit tabs - let parent handle them
    setActiveMainTab(tabId);
    onTabChange?.(tabId, null);
  };

  const handleSecondaryTabClick = (tabId) => {
    setActiveSecondaryTab(tabId);
    onTabChange?.(activeMainTab, tabId);
  };

  useEffect(() => {
    if (activeTab !== activeMainTab) {
      setActiveMainTab(activeTab);
    }
    if (activeSubTab !== activeSecondaryTab) {
      setActiveSecondaryTab(activeSubTab);
    }
  }, [activeTab, activeSubTab]);

  return (
    <Box>
      {/* <SpaceBetween direction="vertical" size="m"> */}
        <Tabs
          onChange={({ detail }) => handleMainTabClick(detail.activeTabId)}
          activeTabId={activeMainTab}
          tabs={mainTabs}
          variant="default"
          disableContentPaddings={true}
        />
      {/* </SpaceBetween> */}
    </Box>
  );
};

export default MenuBar;
